import React, { useState, useEffect } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";

function XBTIBanner() {
  const [visible, setVisible] = useState(true);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (visible) {
      document.body.classList.add('has-xbti-banner');
    } else {
      document.body.classList.remove('has-xbti-banner');
    }
    return () => {
      document.body.classList.remove('has-xbti-banner');
    };
  }, [visible]);

  if (!visible) return null;

  const handleClick = () => {
    // Navigate to XBTI test page
    window.location.href = "https://xmp.mobvista.com/cn/xbti.html?utm_source=xbti&utm_medium=marketing&utm_campaign=xbtitest&from_type=marketing&referer=xbtitest&lang=zh-CN"
  };

  return (
    <div className="xbti_banner_container">
      <div className="bg_svg_wrapper">
        <svg width="100%" height="100%" viewBox="0 0 1200 52" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="120" cy="26" r="80" fill="#2563EB" fillOpacity="0.07" />
          <circle cx="1100" cy="26" r="100" fill="#7C3AED" fillOpacity="0.07" />
          <circle cx="600" cy="60" r="120" fill="#0EA5E9" fillOpacity="0.05" />
        </svg>
      </div>

      <div className="content_wrapper">
        <div className="hot_tag">🔥 热门</div>
        <div className="divider"></div>
        <span className="text">测 XBTI，解锁你的投放人格</span>
        <a
          className="test_btn"
          target="_blank"
          href="https://xmp.mobvista.com/cn/xbti.html?utm_source=xbti&utm_medium=marketing&utm_campaign=xbtitest&from_type=marketing&referer=xbtitest&lang=zh-CN"
        >
          立即测试 →
        </a>
      </div>

      <div className="close_btn" onClick={() => setVisible(false)}>
        ✕
      </div>
    </div>
  );
}

export default XBTIBanner;
